import { useState } from 'react';
import { deleteMessage } from '../api';

interface Props { code: string; }

export function DeletePage({ code }: Props) {
  const [status, setStatus] = useState<'confirm' | 'loading' | 'success' | 'error'>('confirm');
  const [errorMsg, setErrorMsg] = useState('');

  const handleDelete = async () => {
    setStatus('loading');
    try {
      await deleteMessage(code);
      setStatus('success');
    } catch (err) {
      setStatus('error');
      setErrorMsg(err instanceof Error ? err.message : 'Delete failed');
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d1a] flex items-center justify-center p-4">
      <div className="bg-[#1a1a2e] rounded-2xl p-8 max-w-md w-full text-center border border-[#2d2d4e]">
        {status === 'confirm' && (
          <>
            <div className="text-5xl mb-4">🗑️</div>
            <h2 className="text-xl font-bold text-slate-200 mb-2">Remove your message?</h2>
            <p className="text-slate-400 mb-6">
              This will remove your message from the farewell card.
            </p>
            <div className="flex gap-3">
              <a
                href="/"
                className="flex-1 px-4 py-2 border border-[#2d2d4e] text-slate-400 rounded-lg hover:border-slate-500 transition-colors"
              >
                Keep it
              </a>
              <button
                onClick={handleDelete}
                className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium"
              >
                Remove it
              </button>
            </div>
          </>
        )}
        {status === 'loading' && <p className="text-slate-400">Removing your message…</p>}
        {status === 'success' && (
          <>
            <div className="text-5xl mb-4">✓</div>
            <h2 className="text-xl font-bold text-slate-300 mb-2">Message removed</h2>
            <p className="text-slate-400">Your message has been taken off the card.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-5xl mb-4">🔗</div>
            <h2 className="text-xl font-bold text-red-400 mb-2">Link not valid</h2>
            <p className="text-slate-400">
              {errorMsg || 'This delete link has already been used or is no longer valid.'}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
